import Vue from 'vue';
import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';
import { LoginTypes } from '@/utils/enums';
import { getHistorySummary, getHistoryWithPagination } from '../../utils/api';
import snq from 'snq';

Vue.use(Vuex);

const TODAY = new Date();
let day = TODAY.getDate();
let dayLastWeek = day - 7;

if (dayLastWeek <= 0) {
  dayLastWeek = 1;
}
const state = {
  rangeStart: new Date(TODAY.getFullYear(), TODAY.getMonth(), dayLastWeek),
  rangeEnd: new Date(TODAY.getFullYear(), TODAY.getMonth(), day),
  dataList: [],
  dataFields: [],
  historyStatus: {
    loading: false,
    success: false,
    error: false,
  },
  historySummaryStatus: {
    loading: false,
    success: false,
    error: false,
  },
  selectedFilter: 'VX_HISTORY', // VX_HISTORY | VX_OPEN_BETS | VX_GRADED_BETS
  selectedSubFilter: 'VX_SPORTS', // VX_SPORTS | VX_MONEY
  historyData: [],
  historySummary: [],
};

const getters = {
  getField,
};

const mutations = {
  updateField,
  updateHistoryStatus(state, row) {
    state.historyStatus = {
      ...state.historyStatus,
      ...row,
    };
  },
  updateHistorySummaryStatus(state, row) {
    state.historySummaryStatus = {
      ...state.historySummaryStatus,
      ...row,
    };
  },
  setHistoryData(state, arr) {
    state.historyData = arr;
  },
  resetHistoryData(state, arr) {
    state.historyData = arr
  },
  setHistorySummary(state, arr) {
    state.historySummary = arr;
  },
};

const actions = {
  tryGetHistory(
    { commit, rootState },
    { startDate, endDate, category, pageSize, pageIndex, callback,  },
  ) {
    if (rootState.player.loginType !== LoginTypes.Player) {
      return;
    }
    if (!callback) {
      commit('updateHistoryStatus', {
        loading: true,
        success: false,
        error: false,
      });
    }

    const lineStyle = rootState.settings.selectedOddType ? rootState.settings.selectedOddType : rootState.player.player.LyneStyle;
    getHistoryWithPagination({ startDate, endDate, category, pageSize, pageIndex,lineStyle }).then((r) => {
      if (r.data.IsSuccess) {
        commit('updateHistoryStatus', { success: true });
        commit(
          'setHistoryData',
          snq(() => r.data.Data.Data, []),
        );
      } else {
        commit('updateHistoryStatus', { error: true });
        commit('setHistoryData', []);
      }
      callback && callback(r.data.IsSuccess);
      commit('updateHistoryStatus', { loading: false });
    });
  },
  tryGetHistorySummary({ commit, rootState }, { startDate, endDate }) {
    if (rootState.player.loginType !== LoginTypes.Player) {
      return;
    }
    commit('updateHistorySummaryStatus', {
      loading: true,
      success: false,
      error: false,
    });
    getHistorySummary({ startDate, endDate }).then((r) => {
      if (r.data.IsSuccess) {
        commit('updateHistorySummaryStatus', { success: true });
        commit('setHistorySummary', r.data.Data);
      } else {
        commit('updateHistorySummaryStatus', { error: true });
      }
      commit('updateHistorySummaryStatus', { loading: false });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
